/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthAdminRouteImport } from './routes/_auth/admin'
import { Route as AuthAdminIndexRouteImport } from './routes/_auth/admin/index'
import { Route as AuthAdminDeletedRouteImport } from './routes/_auth/admin/deleted'
import { Route as AuthAdminUsersRouteImport } from './routes/_auth/admin/users'
import { Route as AuthDocumentsIndexRouteImport } from './routes/_auth/documents/index'
import { Route as AuthDocumentsDocIdRouteImport } from './routes/_auth/documents/$docId'
import { Route as AuthAdminGlossariesIndexRouteImport } from './routes/_auth/admin/glossaries/index'
import { Route as AuthAdminGlossariesGlossaryIdRouteImport } from './routes/_auth/admin/glossaries/$glossaryId'
import { Route as AuthDocumentsDocIdIndexRouteImport } from './routes/_auth/documents/$docId/index'
import { Route as AuthDocumentsDocIdEditRouteImport } from './routes/_auth/documents/$docId/edit'
import { Route as AuthDocumentsDocIdPreparingRouteImport } from './routes/_auth/documents/$docId/preparing'
import { Route as AuthDocumentsDocIdReviewRouteImport } from './routes/_auth/documents/$docId/review'
import { Route as AuthDocumentsDocIdTextsRouteImport } from './routes/_auth/documents/$docId/texts'
import { Route as AuthDocumentsDocIdTranslatingRouteImport } from './routes/_auth/documents/$docId/translating'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminDeletedRoute = AuthAdminDeletedRouteImport.update({
  id: '/deleted',
  path: '/deleted',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminUsersRoute = AuthAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthDocumentsIndexRoute = AuthDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocumentsDocIdRoute = AuthDocumentsDocIdRouteImport.update({
  id: '/documents/$docId',
  path: '/documents/$docId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminGlossariesIndexRoute =
  AuthAdminGlossariesIndexRouteImport.update({
    id: '/glossaries/',
    path: '/glossaries/',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminGlossariesGlossaryIdRoute =
  AuthAdminGlossariesGlossaryIdRouteImport.update({
    id: '/glossaries/$glossaryId',
    path: '/glossaries/$glossaryId',
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthDocumentsDocIdIndexRoute = AuthDocumentsDocIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthDocumentsDocIdRoute,
} as any)
const AuthDocumentsDocIdEditRoute = AuthDocumentsDocIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AuthDocumentsDocIdRoute,
} as any)
const AuthDocumentsDocIdPreparingRoute =
  AuthDocumentsDocIdPreparingRouteImport.update({
    id: '/preparing',
    path: '/preparing',
    getParentRoute: () => AuthDocumentsDocIdRoute,
  } as any)
const AuthDocumentsDocIdReviewRoute =
  AuthDocumentsDocIdReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthDocumentsDocIdRoute,
  } as any)
const AuthDocumentsDocIdTextsRoute = AuthDocumentsDocIdTextsRouteImport.update({
  id: '/texts',
  path: '/texts',
  getParentRoute: () => AuthDocumentsDocIdRoute,
} as any)
const AuthDocumentsDocIdTranslatingRoute =
  AuthDocumentsDocIdTranslatingRouteImport.update({
    id: '/translating',
    path: '/translating',
    getParentRoute: () => AuthDocumentsDocIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/admin/deleted': typeof AuthAdminDeletedRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/documents/$docId': typeof AuthDocumentsDocIdRouteWithChildren
  '/admin/': typeof AuthAdminIndexRoute
  '/documents/': typeof AuthDocumentsIndexRoute
  '/admin/glossaries/$glossaryId': typeof AuthAdminGlossariesGlossaryIdRoute
  '/documents/$docId/edit': typeof AuthDocumentsDocIdEditRoute
  '/documents/$docId/preparing': typeof AuthDocumentsDocIdPreparingRoute
  '/documents/$docId/review': typeof AuthDocumentsDocIdReviewRoute
  '/documents/$docId/texts': typeof AuthDocumentsDocIdTextsRoute
  '/documents/$docId/translating': typeof AuthDocumentsDocIdTranslatingRoute
  '/admin/glossaries/': typeof AuthAdminGlossariesIndexRoute
  '/documents/$docId/': typeof AuthDocumentsDocIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthIndexRoute
  '/admin/deleted': typeof AuthAdminDeletedRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/admin': typeof AuthAdminIndexRoute
  '/documents': typeof AuthDocumentsIndexRoute
  '/admin/glossaries/$glossaryId': typeof AuthAdminGlossariesGlossaryIdRoute
  '/documents/$docId/edit': typeof AuthDocumentsDocIdEditRoute
  '/documents/$docId/preparing': typeof AuthDocumentsDocIdPreparingRoute
  '/documents/$docId/review': typeof AuthDocumentsDocIdReviewRoute
  '/documents/$docId/texts': typeof AuthDocumentsDocIdTextsRoute
  '/documents/$docId/translating': typeof AuthDocumentsDocIdTranslatingRoute
  '/admin/glossaries': typeof AuthAdminGlossariesIndexRoute
  '/documents/$docId': typeof AuthDocumentsDocIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/admin': typeof AuthAdminRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/_auth/admin/deleted': typeof AuthAdminDeletedRoute
  '/_auth/admin/users': typeof AuthAdminUsersRoute
  '/_auth/documents/$docId': typeof AuthDocumentsDocIdRouteWithChildren
  '/_auth/admin/': typeof AuthAdminIndexRoute
  '/_auth/documents/': typeof AuthDocumentsIndexRoute
  '/_auth/admin/glossaries/$glossaryId': typeof AuthAdminGlossariesGlossaryIdRoute
  '/_auth/documents/$docId/edit': typeof AuthDocumentsDocIdEditRoute
  '/_auth/documents/$docId/preparing': typeof AuthDocumentsDocIdPreparingRoute
  '/_auth/documents/$docId/review': typeof AuthDocumentsDocIdReviewRoute
  '/_auth/documents/$docId/texts': typeof AuthDocumentsDocIdTextsRoute
  '/_auth/documents/$docId/translating': typeof AuthDocumentsDocIdTranslatingRoute
  '/_auth/admin/glossaries/': typeof AuthAdminGlossariesIndexRoute
  '/_auth/documents/$docId/': typeof AuthDocumentsDocIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/admin/deleted'
    | '/admin/users'
    | '/documents/$docId'
    | '/admin/'
    | '/documents/'
    | '/admin/glossaries/$glossaryId'
    | '/documents/$docId/edit'
    | '/documents/$docId/preparing'
    | '/documents/$docId/review'
    | '/documents/$docId/texts'
    | '/documents/$docId/translating'
    | '/admin/glossaries/'
    | '/documents/$docId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/admin/deleted'
    | '/admin/users'
    | '/admin'
    | '/documents'
    | '/admin/glossaries/$glossaryId'
    | '/documents/$docId/edit'
    | '/documents/$docId/preparing'
    | '/documents/$docId/review'
    | '/documents/$docId/texts'
    | '/documents/$docId/translating'
    | '/admin/glossaries'
    | '/documents/$docId'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/admin'
    | '/_auth/'
    | '/_auth/admin/deleted'
    | '/_auth/admin/users'
    | '/_auth/documents/$docId'
    | '/_auth/admin/'
    | '/_auth/documents/'
    | '/_auth/admin/glossaries/$glossaryId'
    | '/_auth/documents/$docId/edit'
    | '/_auth/documents/$docId/preparing'
    | '/_auth/documents/$docId/review'
    | '/_auth/documents/$docId/texts'
    | '/_auth/documents/$docId/translating'
    | '/_auth/admin/glossaries/'
    | '/_auth/documents/$docId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/': {
      id: '/_auth/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/deleted': {
      id: '/_auth/admin/deleted'
      path: '/deleted'
      fullPath: '/admin/deleted'
      preLoaderRoute: typeof AuthAdminDeletedRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/users': {
      id: '/_auth/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminUsersRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/documents/': {
      id: '/_auth/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthDocumentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/documents/$docId': {
      id: '/_auth/documents/$docId'
      path: '/documents/$docId'
      fullPath: '/documents/$docId'
      preLoaderRoute: typeof AuthDocumentsDocIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/glossaries/': {
      id: '/_auth/admin/glossaries/'
      path: '/glossaries'
      fullPath: '/admin/glossaries/'
      preLoaderRoute: typeof AuthAdminGlossariesIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/glossaries/$glossaryId': {
      id: '/_auth/admin/glossaries/$glossaryId'
      path: '/glossaries/$glossaryId'
      fullPath: '/admin/glossaries/$glossaryId'
      preLoaderRoute: typeof AuthAdminGlossariesGlossaryIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/documents/$docId/': {
      id: '/_auth/documents/$docId/'
      path: '/'
      fullPath: '/documents/$docId/'
      preLoaderRoute: typeof AuthDocumentsDocIdIndexRouteImport
      parentRoute: typeof AuthDocumentsDocIdRoute
    }
    '/_auth/documents/$docId/edit': {
      id: '/_auth/documents/$docId/edit'
      path: '/edit'
      fullPath: '/documents/$docId/edit'
      preLoaderRoute: typeof AuthDocumentsDocIdEditRouteImport
      parentRoute: typeof AuthDocumentsDocIdRoute
    }
    '/_auth/documents/$docId/preparing': {
      id: '/_auth/documents/$docId/preparing'
      path: '/preparing'
      fullPath: '/documents/$docId/preparing'
      preLoaderRoute: typeof AuthDocumentsDocIdPreparingRouteImport
      parentRoute: typeof AuthDocumentsDocIdRoute
    }
    '/_auth/documents/$docId/review': {
      id: '/_auth/documents/$docId/review'
      path: '/review'
      fullPath: '/documents/$docId/review'
      preLoaderRoute: typeof AuthDocumentsDocIdReviewRouteImport
      parentRoute: typeof AuthDocumentsDocIdRoute
    }
    '/_auth/documents/$docId/texts': {
      id: '/_auth/documents/$docId/texts'
      path: '/texts'
      fullPath: '/documents/$docId/texts'
      preLoaderRoute: typeof AuthDocumentsDocIdTextsRouteImport
      parentRoute: typeof AuthDocumentsDocIdRoute
    }
    '/_auth/documents/$docId/translating': {
      id: '/_auth/documents/$docId/translating'
      path: '/translating'
      fullPath: '/documents/$docId/translating'
      preLoaderRoute: typeof AuthDocumentsDocIdTranslatingRouteImport
      parentRoute: typeof AuthDocumentsDocIdRoute
    }
  }
}

interface AuthAdminRouteChildren {
  AuthAdminDeletedRoute: typeof AuthAdminDeletedRoute
  AuthAdminUsersRoute: typeof AuthAdminUsersRoute
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
  AuthAdminGlossariesGlossaryIdRoute: typeof AuthAdminGlossariesGlossaryIdRoute
  AuthAdminGlossariesIndexRoute: typeof AuthAdminGlossariesIndexRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminDeletedRoute: AuthAdminDeletedRoute,
  AuthAdminUsersRoute: AuthAdminUsersRoute,
  AuthAdminIndexRoute: AuthAdminIndexRoute,
  AuthAdminGlossariesGlossaryIdRoute: AuthAdminGlossariesGlossaryIdRoute,
  AuthAdminGlossariesIndexRoute: AuthAdminGlossariesIndexRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthDocumentsDocIdRouteChildren {
  AuthDocumentsDocIdEditRoute: typeof AuthDocumentsDocIdEditRoute
  AuthDocumentsDocIdPreparingRoute: typeof AuthDocumentsDocIdPreparingRoute
  AuthDocumentsDocIdReviewRoute: typeof AuthDocumentsDocIdReviewRoute
  AuthDocumentsDocIdTextsRoute: typeof AuthDocumentsDocIdTextsRoute
  AuthDocumentsDocIdTranslatingRoute: typeof AuthDocumentsDocIdTranslatingRoute
  AuthDocumentsDocIdIndexRoute: typeof AuthDocumentsDocIdIndexRoute
}

const AuthDocumentsDocIdRouteChildren: AuthDocumentsDocIdRouteChildren = {
  AuthDocumentsDocIdEditRoute: AuthDocumentsDocIdEditRoute,
  AuthDocumentsDocIdPreparingRoute: AuthDocumentsDocIdPreparingRoute,
  AuthDocumentsDocIdReviewRoute: AuthDocumentsDocIdReviewRoute,
  AuthDocumentsDocIdTextsRoute: AuthDocumentsDocIdTextsRoute,
  AuthDocumentsDocIdTranslatingRoute: AuthDocumentsDocIdTranslatingRoute,
  AuthDocumentsDocIdIndexRoute: AuthDocumentsDocIdIndexRoute,
}

const AuthDocumentsDocIdRouteWithChildren =
  AuthDocumentsDocIdRoute._addFileChildren(AuthDocumentsDocIdRouteChildren)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
  AuthDocumentsDocIdRoute: typeof AuthDocumentsDocIdRouteWithChildren
  AuthDocumentsIndexRoute: typeof AuthDocumentsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
  AuthDocumentsDocIdRoute: AuthDocumentsDocIdRouteWithChildren,
  AuthDocumentsIndexRoute: AuthDocumentsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
